const NetlifyFuncPreifx = "/.netlify/functions/";
const EmailTemplatePath = "/.netlify/functions/emails";
export const LOGIN_URL = `${NetlifyFuncPreifx}login`;
export const LOGOUT_URL = `${NetlifyFuncPreifx}logout`;
export const RECOVER_PASSWORD_URL = "/change-password";
export const REFRESH_URL = `${NetlifyFuncPreifx}refreshToken`;
export const CALLBACK_URL = `${NetlifyFuncPreifx}callback`;
export const DEACTIVATE_URL = `${NetlifyFuncPreifx}deactivated`;
export const CHANGEPASSWORD_URL = `${NetlifyFuncPreifx}changePassword`;
export const UNVERIFIEDCALLBACK_URL = `${NetlifyFuncPreifx}unverified-callback`;
export const GIFTAIDEMAIL_URL = `${NetlifyFuncPreifx}triggerGiftAidForAdvancementEmail`;
export const ALUMNIEMAIL_URL = `${NetlifyFuncPreifx}triggerAlumniJobBoardEmail`;
export const CONTACTUSEMAIL_URL = `${NetlifyFuncPreifx}triggerContactUsEmail`;
export const CHANGEEMAILNOTIFICATION_URL = `${NetlifyFuncPreifx}triggerEmailchangeNotification`;
export const GATEDCONTENTEMAIL_URL = `${NetlifyFuncPreifx}triggerGatedContent`; //no call
export const THINKEMAIL_URL = `${NetlifyFuncPreifx}triggerThinkVerifyEmail`;
export const DPCEMAIL_URL = `${NetlifyFuncPreifx}triggerDPCEmail`;
export const TRANSATIONSTATUS_URL = `${NetlifyFuncPreifx}userTransactionStatus`;
// email template paths
export const CONTACTUS_TEMPLATE = `${EmailTemplatePath}/contactUsEmail`;
export const CONTACTUSWITHTOPIC_TEMPLATE = `${EmailTemplatePath}/contactUsWithTopicEmail`;
export const GIFTAID_TEMPLATE = `${EmailTemplatePath}/giftAidForAdvancement`;
export const THINK_TEMPLATE = `${EmailTemplatePath}/thinkVerifyEmail`;
export const GATEDCONTENT_TEMPLATE = `${EmailTemplatePath}/gatedVerifyEmail`;
export const CHANGEMAIL_TEMPLATE = `${EmailTemplatePath}/changeEmailNotification`;
export const ALUMNIJOBBOARD_TEMPLATE = `${EmailTemplatePath}/alumniJobBoardEmail`;
export const DPC_TEMPLATE = `${EmailTemplatePath}/dpcEmail`;
